import { GET_TENANT_USER_DETAILS } from "../../actions/actionTypes";

export const tenantUserDetailsReducer = (state={}, action) => {
    switch(action.type){
        case GET_TENANT_USER_DETAILS:
            return action.payload;
        default:
            return state;
    }
}